import React from 'react';

const FilledCaretDownIcon = (props) => (
  <svg {...props} viewBox='0 0 5 4' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2.03141 3.25L0.000322342 0H4.0625L2.03141 3.25Z' fill={props.fill} />
  </svg>
);

export default FilledCaretDownIcon;
